// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1___e034abcd2cf5f227f98","cls2":"UserTaggingPingBodyStyles-cls2___515ad90ba33eb0ea42d UserTaggingPingBodyStyles-cls1___e034abcd2cf5f227f98"};